module.exports = __webpack_public_path__ + "img/icon_offline@2x.2a7af30c.png";